// Single source of truth for referral-code capture + retrieval.
//
// Two capture paths historically wrote DIFFERENT localStorage keys:
//   - useReferral() (app-wide, fires on every page incl. the SEO surfaces)
//     wrote `hevolve_referral_code`
//   - Join.js (/join?ref=) wrote `referral_code`
// ...and the signup flow read neither into its payload, so the backend's
// referral attribution (api.py: DistributionService.use_referral_code +
// the `signup` channel event) never fired for organic inbound. Every
// referred signup landed as `direct`. This module reconciles the two keys
// so capture and consumption agree, and is a leaf (imports nothing) so both
// hooks/useReferral.js and services/socialApi.js can use it without a cycle.

// Primary key (what getReferralCode has always returned) first, legacy
// /join key second. We write BOTH on capture and read EITHER on retrieval.
const PRIMARY_KEY = 'hevolve_referral_code';
const LEGACY_KEY = 'referral_code';

export function storeReferralCode(code) {
  if (!code) return;
  try {
    // Don't overwrite an already-captured code — first touch wins, matching
    // the prior useReferral behavior (first channel that brought them in).
    if (!localStorage.getItem(PRIMARY_KEY)) {
      localStorage.setItem(PRIMARY_KEY, code);
      localStorage.setItem('hevolve_referral_ts', Date.now().toString());
    }
    // Keep the legacy key in sync so any raw reader (and the /join path)
    // sees the same value.
    if (!localStorage.getItem(LEGACY_KEY)) {
      localStorage.setItem(LEGACY_KEY, code);
    }
  } catch {
    // localStorage blocked (private mode / SSR) — degrade silently.
  }
}

export function getReferralCode() {
  try {
    return localStorage.getItem(PRIMARY_KEY) || localStorage.getItem(LEGACY_KEY) || null;
  } catch {
    return null;
  }
}
